/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import './ErrorScreen.scss';

function ErrorScreen({error}) {
    return (
       <div className="error-screen d-flex align-items-center justify-content-center flex-column">
         <img src="https://images2.bangbros.com/bangbros/h1/bbrothers_logo.png" className="mb-4 error-screen__img" alt=""/>
         <h3>Uh oh! Looks like something went wrong.</h3>
         <p>Hopefully you finished by now... If you haven't, keep calm, we are working on it! </p>
         <div className="link-button" onClick={() => document.location.reload()}>Click here to Try again</div>
       </div>
    );
}

export default ErrorScreen;
